<div class="cart-empty">
  <div class="cart-empty-details color-black">
    <p class="text-b2-l-700 text-md-h4-l">в корзине ничего нет</p>
    <a
      class="text-b3-m-300 link-black link-hover-black link-underlined link-hover-underlined"
      [routerLink]="{ cxRoute: 'category', params: { code: 'catalog' } } | cxUrl"
    >
      перейти в каталог
    </a>
  </div>
  <div class="cart-empty-recommendation-carousel">
    <sd-product-carousel [position]="1" data-testid="product-carousel-empty-cart"></sd-product-carousel>
  </div>
</div>
